require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-coffee-with-cam-or-retired-but-inspired.json") })
        }
      }, "path---es-articles-coffee-with-cam-or-retired-but-inspired");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-coffee-with-cam-or-retired-but-inspired!./.cache/json/es-articles-coffee-with-cam-or-retired-but-inspired.json
// module id = 2049
// module chunks = 231608221292675